export class ChartRenderedEvent {
	constructor() {}
}

export class ChartPagesReadyEvent {
	constructor() {}
}
